import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { api } from "@/APIRequests";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";
import dayjs from "@/lib/helpers/dayjs";
import images from "@/utils/images";

export function TodaysSchedule({ calls }) {
  const [avatarUrls, setAvatarUrls] = useState({});

  useEffect(() => {
    if (!calls) return;

    calls.forEach((call) => {
      if (!call.patient_avatar) return;

      (async () => {
        const urlParams = { patientId: call.patient_username };
        const data = { key: call.patient_avatar };
        const cleanResponse = await api.shared.fetch_patient_avatar({ data, urlParams });

        if (cleanResponse?.message) {
          setAvatarUrls((prev) => ({ ...prev, [call.patient_username]: cleanResponse.message }));
        }
      })();
    });
  }, [calls]);

  return (
    <DashboardCard2 className="tw:justify-between tw:p-5!" rawChildren>
      <p>
        <strong>TODAY'S SCHEDULE</strong>
      </p>

      <ul className="tw:mt-3 tw:flex tw:flex-col tw:gap-2">
        {calls?.slice(0, 3).map((call) => {
          const localTime = dayjs(call.timestamp, "HH:mm").format("hh:mm A");
          const avatarUrl = avatarUrls[call.patient_username];

          return (
            <li className="tw:flex tw:items-center tw:justify-start" key={call.callId}>
              <img
                alt=""
                className="tw:mr-2 tw:aspect-square tw:size-6"
                src={avatarUrl ?? images("./common/avatar.png")}
                width="40"
              />

              <div data-private="true">{call.patient_name}</div>
              <span className="tw:ml-auto">{localTime}</span>
            </li>
          );
        })}

        {!calls && <li>No Calls Today</li>}
      </ul>

      {calls && (
        <div className="tw:mt-auto">
          <hr className="m-0" />

          <Link
            className="tw:mt-2 tw:flex tw:place-self-center"
            style={{ color: "#0CD0A7" }}
            to="/app/schedule"
          >
            View All
          </Link>
        </div>
      )}
    </DashboardCard2>
  );
}
